import React from 'react';
import { useTheme } from 'styled-components';
import { useDispatch } from 'react-redux';
import { BUTTON_STROKES } from 'shared/utils/buttonTextStrokes';
import { PurchaseTypes } from 'shared/utils/routeParamConstants';
import { purchaseActionTriggers } from 'shared/constants/userActions';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import Logger from 'shared/lib/analytics/logger';
import { assignTransationUUID } from 'shared/state/actions/purchase';
import useSendInitiatePurchaseLog from 'shared/hooks/purchase/useSendInitiatePurchaseLog';
import Button from '../../../components/Button/Button';

function LtoPurchaseWrapper({ purchaseHandler, limitedTimeOfferData }) {
  const { LimitedTimeOffer } = useTheme();
  const dispatch = useDispatch();
  const { sendInitiatePurchaseLog } = useSendInitiatePurchaseLog();
  const ltoPurchaseHandler = () => {
    purchaseHandler();
    const UUID = Logger.generateUUID();
    dispatch(assignTransationUUID(UUID));
    const purchaseLogObject = {
      sku: limitedTimeOfferData?.CURRENCY_ITEM_ID,
      amount: limitedTimeOfferData?.PRICE,
      pType: PurchaseTypes.CURRENCY,
      trigger: purchaseActionTriggers.LIMITED_TIME_OFFER_BUY_BUTTON,
      UUID,
    };
    sendInitiatePurchaseLog(purchaseLogObject);
  };
  return (
    <div className="buttonContainer" style={LimitedTimeOffer.ButtonContainer} onClick={ltoPurchaseHandler}>
      <div style={LimitedTimeOffer.BuyButtonContainer}>
        <Button
          textStroke={BUTTON_STROKES.GREEN}
          label={getText(TEXT_KEY.BUY)}
          imageSource={assetSource(ASSET_KEY.PINK_BUTTON)}
          onClick={ltoPurchaseHandler}
          containerStyle={LimitedTimeOffer.BuyButton}
          imageStyle={LimitedTimeOffer.BuyButtonImageStyle}
          textStyle={LimitedTimeOffer.BuyButtonTextStyle}
          isDebounce={true}
        />
      </div>
    </div>
  );
}

export default LtoPurchaseWrapper;

